export default __webpack_public_path__ + "static/media/icon-terminated-members.6724ac11.svg";